import { useAtomValue } from 'jotai';

import { useCanProviderUseTranscription } from '../../provider/session-recording/useCanProviderUseTranscriptionCallback';
import { AudioRecordingState, participantCountAtom, recordingStateAtom } from '../../video-sdk';

export function useRecordingControl(hasAppointment: boolean = false) {
  const recordingState = useAtomValue(recordingStateAtom).value;
  const inSession = !!useAtomValue(participantCountAtom);
  const canProviderUseTranscription = useCanProviderUseTranscription();
  const isVisible =
    (inSession && hasAppointment && canProviderUseTranscription) || recordingState === AudioRecordingState.RECORDING;

  return {
    isVisible,
    recordingState,
  };
}
